module.exports = __webpack_public_path__ + "img/gob-yucatan.53df4033.png";